import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom';
import MainLayout from 'newComponents/Layout/MainLayout'
import ModalLoading from 'newComponents/Loading';
import { useValidateAccount } from 'newHooks/useValidateAccount';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';

const PreHome = () => {
    const { flow, account, dataCard, showView } = useValidateAccount()
    const [ loading, setLoading ] = useState(true)
    const history = useHistory();

    useEffect(()=>{
        if(flow){
            if(flow === 1){
                // 1 = usuario sin login
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}beneficios`);
            }
            else if(flow === 2){
                // 2 = usuario con login, sin tarjeta asignada
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta`);
            }
            else if(flow === 3){
                // 3 = usuario con login, con tarjeta asignada
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`);
            }
        }
    },[ flow ])

    return(
        <MainLayout>
            { loading && <ModalLoading /> }
        </MainLayout>
    )
}

export default PreHome